import { Alert } from 'antd';
import React from 'react';

const StagingAlert = () => {
  const alertStyle = {
    position: 'fixed',
    bottom: 0,
    width: 900,
    fontWeight: 'bold',
    marginBottom: 20,
    marginLeft: -450,
    left: '50%',
    zIndex: 99,
  };
  const alertMessage = (
    <>
      This is a staging site! NiFi flows are NOT integrated with these mappings by default. To
      access the production site please go to{' '}
      <a href="https://data-admin.centralit.1up.health/">
        https://data-admin.centralit.1up.health/
      </a>
    </>
  );

  return <Alert showIcon style={alertStyle} message={alertMessage} type="warning" />;
};

export default StagingAlert;
